// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"93ba0acd","739":"80d8afd4"}[chunkId] + ".chunk.js";
};